import { AnimatePresence, motion } from "framer-motion";
import React, { useEffect, useState } from "react";
import Joinus from "../../common/Joinus";
import { googleAdsServiceDetails, gridgoogle, initialStates, servicesgoogle } from "../home/Constant";
import WhatWeDo from "./WhatWeDo";
import DigitalGoogleAni from "./DigitalGoogleAni";

const DigitalGoogle = () => {
  const [showAll, setShowAll] = useState(false);
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  const [expandedItems, setExpandedItems] = useState({});
  const toggleContent = (id) => {
    setExpandedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };
  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="margin-topall">
      <section className="py-5 service-position">
        <div className="container">
          <div className="metagoogle-bg-round">
            {colors.map((color, i) => (
              <div
                key={i}
                id={`dot_00${i}`}
                style={{
                  position: "absolute",
                  border: `${i == 0 ? "9px solid white" : "none"}`,
                  top: `${initialStates[i].top}px`,
                  left: `${initialStates[i].left}px`,
                  width: `${initialStates[i].width}px`,
                  height: `${initialStates[i].height}px`,
                  marginLeft: `${initialStates[i].marginLeft}px`,
                  opacity: initialStates[i].opacity,
                  backgroundColor: color,
                  borderRadius: "50%",
                  zIndex: 1000,
                  pointerEvents: "none",
                  willChange: "top, left, width, height, opacity, margin-left",
                }}
              />
            ))}
          </div>
          <div className="pos-z-index">
            <div className="row justify-content-center">
              <div className="col-lg-8"
                data-aos="fade-right" data-aos-delay="300"
              >
                <div className="">
                  <h5 className="yellow-sub-heading text-center py-2 ">
                    Google Ads Marketing
                  </h5>
                  {/* <h4 className="black-service-heading text-center font-align mt-3">
                                    Unlock 5x Revenue Growth
                                </h4> */}
                  <div className="smsgoogle-sub-heading">
                    Google Ads Marketing is a powerful digital advertising solution that helps 
                    businesses reach the right audience at the right time and achieve measurable 
                    growth. With Google Ads, your business can appear prominently across Google 
                    Search, Display Network, YouTube, and Shopping results, ensuring maximum 
                    visibility and high-intent traffic. Our Google Ads Marketing services enable 
                    businesses to promote products and services through Search Ads, Display Ads, 
                    Video Ads, and Shopping Ads, all backed by data-driven strategies. We continuously 
                    track ad performance, analyze user behavior, and optimize campaigns in real time 
                    to improve clicks, conversions, and return on ad spend (ROAS).
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <WhatWeDo data={googleAdsServiceDetails} />
      <DigitalGoogleAni />
      <section className="overflow-hidden">
        <div className="container">

          {gridgoogle.map((item, index) => (
            <div className="row gridflex">
              <div className={`col-lg-6 ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"
              >
                <div className="d-flex gap-2">
                  <div className="circleservice">{index + 1}</div>
                  <h1 className="servicebenefit">{item.heading}</h1>
                </div>
                <div className="servicefontb ">
                  <p className="py-2">{item.para1}</p>
                </div>
                {/* {expandedItems[index] && <p c className={`servicefontb expandable-content ${expandedItems[index] ? 'expanded' : ''}`}>{item.para2}</p>}
                      <button className="btn-sm readbtn" onClick={() => toggleContent(index)}>
                        {expandedItems[index] ? 'Read Less' : 'Read More'}
                      </button> */}
                <AnimatePresence initial={false}>
                  {expandedItems[index] && (
                    <motion.p
                      key="expand-content"
                      className="servicefontb"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.4 }}
                    >
                      {item.para2}
                    </motion.p>
                  )}
                </AnimatePresence>

                <button className="btn-sm readbtn" onClick={() => toggleContent(index)}>
                  {expandedItems[index] ? "Read Less" : "Read More"}
                </button>
              </div>
              <div className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}
                data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
              >
                <img className="bulkwidth" src={item.img} alt={`Visual for ${item.heading}`} />
              </div>
            </div>
          ))}
        </div>
      </section>
      {/* <WhatDo/> */}
      <section className="py-5">
        <div className="container">
          <div>
            <h1 className="faqfont">FAQs - (Google Ads)</h1>
          </div>
          <div className="py-5"
            data-aos="fade-right" data-aos-delay="300"
          >
            <div class="accordion" id="accordionExample">
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What is Google Ads?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse show"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body sms-span">
                    Google Ads is an online pay-per-click (PPC) advertising
                    platform that helps businesses reach their target audience.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    <span class="me-3 toggle-icon"></span>
                    What are the different types of Google Ads?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    There are three main types: Search Network campaigns
                    (text-based), Display Network campaigns (image-based), and
                    Video campaigns (video-based).
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingThree">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How to get my Google Ads to rank #1?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Focus on ad relevance, user experience, and optimizing your
                    ad rank using Google's auction system.
                  </div>
                </div>
              </div>

              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFour">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFour"
                    aria-expanded="false"
                    aria-controls="collapseFour"
                  >
                    <span class="me-3 toggle-icon"></span>
                    How to set a budget?
                  </button>
                </h2>
                <div
                  id="collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFour"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Calculate your average daily budget by dividing your monthly
                    budget by the average number of days per month.
                  </div>
                </div>
              </div>
              <div class="accordion-item border-top">
                <h2 class="accordion-header" id="headingFive">
                  <button
                    class="accordion-button collapsed d-flex align-items-center"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseFive"
                    aria-expanded="false"
                    aria-controls="collapseFive"
                  >
                    <span class="me-3 toggle-icon"></span>
                    Are Google Ads worth it?
                  </button>
                </h2>
                <div
                  id="collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingFive"
                  data-bs-parent="#accordionExample"
                >
                  <div class="accordion-body">
                    Yes, Google Ads can drive significant value for businesses,
                    offering targeted advertising and measurable ROI
                  </div>
                </div>
              </div>
              {showAll && (
                <>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSix">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSix"
                        aria-expanded="false"
                        aria-controls="collapseSix"
                      >
                        <span class="me-3 toggle-icon"></span>
                        Why are my Google Ads not showing?
                      </button>
                    </h2>
                    <div
                      id="collapseSix"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSix"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Common issues include payment errors, disapproved ads,
                        negative keywords, and scheduling/targeting errors.
                      </div>
                    </div>
                  </div>

                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingSeven">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseSeven"
                        aria-expanded="false"
                        aria-controls="collapseSeven"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How long does it take for Google Ads to work?
                      </button>
                    </h2>
                    <div
                      id="collapseSeven"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingSeven"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        It can take a few days to weeks for search campaigns to
                        show results, while display campaigns may take longer.
                        Allow at least 3 months for a new campaign to mature.
                      </div>
                    </div>
                  </div>
                  <div class="accordion-item border-top">
                    <h2 class="accordion-header" id="headingEight">
                      <button
                        class="accordion-button collapsed d-flex align-items-center"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseEight"
                        aria-expanded="false"
                        aria-controls="collapseEight"
                      >
                        <span class="me-3 toggle-icon"></span>
                        How long for Google Ads to appear?
                      </button>
                    </h2>
                    <div
                      id="collapseEight"
                      class="accordion-collapse collapse"
                      aria-labelledby="headingEight"
                      data-bs-parent="#accordionExample"
                    >
                      <div class="accordion-body">
                        Ads are usually approved within 24-48 hours, but may
                        take an hour or two to appear.
                      </div>
                    </div>
                  </div>
                </>
              )}
              <div className="text-center py-3 ">
                <button
                  className="btn-sm viewbtn"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "View Less" : "View More"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Joinus />
    </div>
  );
};

export default DigitalGoogle;
